import React from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'
import AccountName from 'core/utils/AccountName'
import { ConfirmDialog } from '@carsys/ui'
import { IAccount } from '@cbgms/api'

interface Props {
  open: boolean
  currentVehicleAccount: IAccount
  onClose: () => void
  onConfirm: () => void
}

const ConfirmModalLinkAccount: React.FC<Props> = ({ open, currentVehicleAccount, onConfirm, onClose }) => {
  const { t } = useTranslation()

  return (
    <ConfirmDialog
      open={open}
      title={`${t('link_vehicle_to_workorder.confirm_modal_link_account.title')}`}
      content={
        <Box whiteSpace='break-spaces' data-testid='confirm-modal-link-account-content'>
          {currentVehicleAccount?.Name && (
            <>
              <Typography>{t('link_vehicle_to_workorder.confirm_modal_link_account.change_owner')}:</Typography>
              <AccountName account={currentVehicleAccount} />
            </>
          )}
          {!currentVehicleAccount?.Name && <Typography>{t('link_vehicle_to_workorder.confirm_modal_link_account.link_owner')}</Typography>}
        </Box>
      }
      cancelButtonContent={t('global.no')}
      confirmButtonContent={t('global.yes')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  )
}

export default ConfirmModalLinkAccount
